var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_61181_117885)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.38322 0 0 5.38322 0 12C0 18.6168 5.38322 24 12 24C18.6168 24 24 18.6168 24 12C24 5.38322 18.6168 0 12 0ZM12 22.1538C6.40116 22.1538 1.84617 17.5988 1.84617 12C1.84617 6.4012 6.40116 1.84617 12 1.84617C17.5988 1.84617 22.1538 6.40116 22.1538 12C22.1538 17.5988 17.5988 22.1538 12 22.1538Z",
    fill: "#BFD214"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.58008,
    cy: 12,
    r: 1.5,
    fill: "#BFD214"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 1.5,
    fill: "#BFD214"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.4199,
    cy: 12,
    r: 1.5,
    fill: "#BFD214"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_61181_117885"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.b1232ae64eaacec219a38c2bb6fb9cff.svg";
export { ForwardRef as ReactComponent };